<template>
  <div class="my-table projectSetting">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('projectSettings.txt1')}}</span>
        <span>{{$t('projectSettings.txt2')}} / {{$t('projectSettings.txt3')}} /  
          <span class="link">{{detail.projectName}}  {{$t('projectSettings.txt4')}}</span>
        </span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn ml20" @click="onBack">{{$t('projectSettings.txt5')}}</div>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('projectSettings.txt6')}}</span>
        <div class="flexEnd">
          <div class="searchBtn mr30" @click="setFilePermission">{{$t('projectSettings.txt7')}}</div>
          <div class="searchBtn mr30" @click="handleDelete">{{$t('projectSettings.txt8')}}</div>
        </div>
      </div>
      <div class="editForm editWidth">
        <el-form :model="queryData" :rules="projectRules" ref="queryData" class="demo-ruleForm">
          <el-form-item label="" prop="projectName">
            <div class="projectName">
              <div class="settingTitle">{{$t('projectSettings.txt9')}}</div>
              <el-input :placeholder="$t('projectSettings.txt10')" v-model="queryData.projectName"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="" prop="">
            <div class="radioBox">
              <div class="settingTitle">{{$t('projectSettings.txt11')}}</div>
              <el-row :gutter="10">
                <el-col :span="8">
                  <p>{{$t('projectSettings.txt12')}}</p>
                  <p>
                    <span class="mr10">{{$t('projectSettings.txt13')}}</span>
                    <el-switch v-model="queryData.filePermission.userDownload" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('projectSettings.txt14')}}</span>
                    <el-switch v-model="queryData.filePermission.userEdit" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('projectSettings.txt15')}}</span>
                    <el-switch v-model="queryData.filePermission.userView" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>{{$t('projectSettings.txt16')}}</p>
                  <p>
                    <span class="mr10">{{$t('projectSettings.txt13')}}</span>
                    <el-switch v-model="queryData.filePermission.groupDownload" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('projectSettings.txt14')}}</span>
                    <el-switch v-model="queryData.filePermission.groupEdit" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('projectSettings.txt15')}}</span>
                    <el-switch v-model="queryData.filePermission.groupView" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                </el-col>
                <el-col :span="8">
                  <p>{{$t('projectSettings.txt17')}}</p>
                  <p>
                    <span class="mr10">{{$t('projectSettings.txt13')}}</span>
                    <el-switch v-model="queryData.filePermission.otherDownload" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('projectSettings.txt14')}}</span>
                    <el-switch v-model="queryData.filePermission.otherEdit" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                  <p>
                    <span class="mr10">{{$t('projectSettings.txt15')}}</span>
                    <el-switch v-model="queryData.filePermission.otherView" active-color="#1B3B7C" inactive-color="#ccc"></el-switch>
                  </p>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
          <el-form-item label="" prop="">
            <div class="radioBox">
              <div class="settingTitle">{{$t('projectSettings.txt18')}}</div>
              <el-input
									  class="messageBox"
									  resize='none'
									  type="textarea"
									  :placeholder="$t('projectSettings.txt18')"
									  v-model="queryData.projectDescribe">
									</el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        queryData:{
          filePermission:{
            groupDownload: false,
            groupEdit: false,
            groupView: false,
            otherDownload: false,
            otherEdit: false,
            otherView: false,
            userDownload: false,
            userEdit: false,
            userView: false
          },
          projectId:this.$route.query.id,
          file:this.$route.query.file,
        },
        detail:{},
        projectRules:{}
      };
    },
    created() {
      this.getProjectSettingInfo();
    },

    methods: {
      onBack(){
        this.$router.go(-1);
      },
      // 获取项目设置详细
      async getProjectSettingInfo() {
        let data = {
          projectId: this.queryData.projectId
        }
        const {
          data: res
        } = await this.$http.post("/project/getProjectSettingInfo?"+qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.queryData = res.result;
      },
      // 删除
    handleDelete() {
      this.$confirm(
        '<p class="color666 fz14">'+this.$t('projectSettings.txt19')+'</p><p class="color999 fz14">'+this.$t('projectSettings.txt20')+'</p>',
        this.$t('projectSettings.txt21'),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('projectSettings.txt22'),
          cancelButtonText: this.$t('projectSettings.txt23'),
          type: "warning",
          center: true,
        }
        )
      .then(() => {
        this.deleteProj(this.queryData.projectId);
      })
      .catch(() => {});
    },
    async deleteProj(id) {
      const { data: res } = await this.$http.post("/project/delete?id=" + id
        );
      if (!res.success) {
        return this.$message.error(res.message);
      }
      this.$message({
        type: "success",
        message: this.$t('projectSettings.txt24'),
      });
      this.loadData();
    },
      // 设置文件权限
      async setFilePermission() {
        const {
          data: res
        } = await this.$http.post("/project/edit",this.queryData);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
        	type: 'success',
        	message: this.$t('projectSettings.txt25')
        });
        this.onBack();
      }
    },
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .projectSetting{
    /deep/ .el-upload__input{
      display: none !important;
    }
    .mr10{
      margin-right: 10px;
    }
    .messageBox{
				/deep/ textarea{
					width: 430px;
					height: 250px;
					background: #F4F4F4;
					border: none;
					border-radius: 6px;
				}
			}
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .editForm{
      margin: 0;
      width: 70%;
    }
    .projectName{
      padding-bottom: 30px;
      border-bottom: 1px solid #EBF7F4;
    }
    .settingTitle{
      font-weight: 500;
      color: #222222;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .radioBox{
      p{
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }
  }

</style>
